import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'light' | 'dark' | 'accent' | 'peach';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-brand-ivory/90',
    light: 'bg-brand-pistachio/40',
    dark: 'bg-brand-dark text-white',
    accent: 'bg-brand-eucalyptus/20',
    peach: 'bg-brand-peach/30' // Soft peach
  };
  // Default fallback if background key doesn't exist
  const bgClass = backgrounds[background] || backgrounds.white;
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 w-full relative z-10 ${bgClass} ${className}`} data-id="element-73">
      <div className="max-w-4xl mx-auto w-full" data-id="element-74">{children}</div>
    </section>;
}